import type { ReactElement, SyntheticEvent } from "react"
import type { ButtonAtmProps } from "@onestore/hel/dist/components/atoms/ButtonAtm"
import ButtonAtm from "@onestore/hel/dist/components/atoms/ButtonAtm"
import useFastCheckoutAction from "@gatsby-plugin-basket/hooks/useFastCheckoutAction"
import type { CloudBluePlan } from "@gatsby-plugin-definitions/fragments/CloudBluePlan"
import { showPlanOverLimitModal } from "~/store/basket/actions"
import { getPlansUsageOverLimit } from "~/store/basket/selectors"
import { useAppDispatch, useAppSelector } from "~/store/hooks"

type FastCheckoutButtonProps = ButtonAtmProps & {
  plan: CloudBluePlan[]
}

function FastCheckoutButton({
  onClick,
  href,
  title,
  text,
  color,
  variant,
  size,
  plan,
  rel,
  ...restProps
}: FastCheckoutButtonProps): ReactElement<FastCheckoutButtonProps> {
  const dispatch = useAppDispatch()
  const plansOverLimit = useAppSelector(getPlansUsageOverLimit)
  const { addProductToBasket, isLoading } = useFastCheckoutAction(plan[0])
  const isPlanOverLimit = plansOverLimit.includes(plan[0].flatData.id)

  const handleOnClick = (event: SyntheticEvent) => {
    event.preventDefault()

    if (onClick) {
      onClick(event)
    }

    if (isPlanOverLimit) {
      dispatch(showPlanOverLimitModal())

      return
    }

    addProductToBasket()
  }

  return (
    <ButtonAtm
      onClick={handleOnClick}
      isLoading={isLoading}
      title={title}
      color={color}
      variant={variant}
      size={size}
      rel={rel}
      {...restProps}
    >
      {text}
    </ButtonAtm>
  )
}

export default FastCheckoutButton
